import { Button } from '@mui/material'
import { Download } from '@mui/icons-material'

const SanPedroCalendarCurrent = require("../assets/SanPedroCalendarCurrent.pdf")

export default function DownloadButton({ text, url }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <a href={url} download={text}>
        <Button 
        variant="contained" 
        endIcon={<Download />}
        size="large" // makes padding and height bigger
          style={{
            fontSize: "1.2rem",     // make text bigger
            padding: "12px 24px"    // increase internal padding
          }}
        >
          {text}
        </Button>
      </a>
    </div>
  )
}